import React from "react";
import { motion } from "framer-motion";

const cardInitial = { opacity: 0, y: 10 };
const cardAnimate = { opacity: 1, y: 0 };
const cardTransition = (i) => ({ delay: i * 0.05 });

export const PackagerCard = ({ packager, index, active, onSelect }) => (
  <motion.button
    type="button"
    initial={cardInitial}
    animate={cardAnimate}
    transition={cardTransition(index)}
    onClick={() => onSelect(active ? "" : packager.name)}
    data-testid={`packager-card-${packager.name}`}
    className={`min-w-[140px] max-w-[220px] flex-1 sm:flex-none text-left rounded-2xl border-2 px-4 py-3.5 transition-all hover:-translate-y-0.5 ${
      active
        ? "bg-[#052F24] border-[#052F24] text-[#DFFF00]"
        : "bg-[#F9FAFB] border-transparent text-[#052F24] hover:border-[#052F24]/20"
    }`}
  >
    <div className="font-display font-extrabold text-2xl tracking-tight">{packager.count}</div>
    <div className={`text-sm font-semibold truncate ${active ? "text-[#DFFF00]/90" : "text-[#052F24]/80"}`} title={packager.name}>{packager.name}</div>
    <div className={`text-[11px] mt-0.5 ${active ? "text-[#DFFF00]/60" : "text-[#6B7280]"}`}>
      {packager.funded} funded
    </div>
  </motion.button>
);
